import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/context/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }, [pathname]);
    return null;
}

function Chrome({ children }) {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");
    return (
        <div className="min-h-screen flex flex-col bg-white">
            {!isAdmin && <Header />}
            <div className="flex-1">{children}</div>
            {!isAdmin && <Footer />}
            {!isAdmin && <FloatingActions />}
            {!isAdmin && <CookieBanner />}
        </div>
    );
}

function App() {
    return (
        <HelmetProvider>
            <LanguageProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Chrome>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/legal/impressum" element={<LegalPage type="impressum" />} />
                            <Route path="/legal/privacy" element={<LegalPage type="privacy" />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </Chrome>
                </BrowserRouter>
            </LanguageProvider>
        </HelmetProvider>
    );
}

export default App;
